const DeleteIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.50003 22.125C4.49778 22.4206 4.61288 22.7051 4.82008 22.916C5.02728 23.1269 5.30966 23.247 5.6053 23.25H18.3948C18.6904 23.247 18.9728 23.1269 19.18 22.916C19.3872 22.7051 19.5023 22.4206 19.5 22.125V7.125H4.50003V22.125ZM6.00003 8.625H18V21.75H6.00003V8.625Z"
        fill="#666666"
      />
      <path d="M9.375 10.125H7.875V19.5H9.375V10.125Z" fill="#666666" />
      <path d="M12.75 10.125H11.25V19.5H12.75V10.125Z" fill="#666666" />
      <path d="M16.125 10.125H14.625V19.5H16.125V10.125Z" fill="#666666" />
      <path
        d="M15.375 4.125V1.875C15.375 1.24416 14.9303 0.75 14.3625 0.75H9.6375C9.06975 0.75 8.625 1.24416 8.625 1.875V4.125H3V5.625H21V4.125H15.375ZM10.125 2.25H13.875V4.125H10.125V2.25Z"
        fill="#666666"
      />
    </svg>
  );
};

export default DeleteIcon;
